import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import { ColDef, GridApi, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { ConfigProvider, Input, Pagination, PaginationProps, Select, TreeSelect } from 'antd';
import viVN from 'antd/locale/vi_VN';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getListUserAccount, IAccount } from '../../../../../../api/groupPermission/groupPermissionApi';
import { NodataTable } from '../../../../../../components/NoDataTable';
import useDebounce from '../../../../../../hook/useDebounce';
import useLoading from '../../../../../../hook/useLoading';
import { selectorInfoUser } from '../../../../../../store/slices/infoUserSlice';
import { dataPagination, formatPrice } from '../../../../../../until';
import { useCustomerGroupContext } from '../../../indexV2';
import '../../../style.scss';
import { GROUPTYPE, IInforAddGroup } from '../AddNewGroup';
import { formatNumber } from '../../../../../../services/mixin';


// Cấu hình cột
export const columnDefs: ColDef[] = [
    { headerName: "Mã NV", field: "code", minWidth: 200 },
    { headerName: "Họ tên", field: "fullname", minWidth: 200 },
    { headerName: "Email", field: "email", minWidth: 200 },
    { headerName: "Đơn vị", field: "unit", minWidth: 200 },
    { headerName: "Quyền", field: "permission", minWidth: 200 },

    // { headerName: "CCCD/CMND", field: "cccd", minWidth: 200 },
    // { headerName: "Mã số thuế", field: "maSoThue", flex: 1 },
    // { headerName: "Ngày sinh", field: "ngaySinh", flex: 1 },
    // { headerName: "Giới tính", field: "gioiTinh", flex: 1 },
    // { headerName: "Số điện thoại", field: "soDienThoai", minWidth: 200 },
];

export enum PERMISSION {
    VIEW = 0,
    EDIT = 1,
    DELETE = 2
}
export interface ISelectedUserAccount {
    adminId: number;
    permissionType: PERMISSION;
}
interface IDataDefaulFilterList {
    search?: string;
    listUnit?: number[]
}

const dataDefaulFilterList: IDataDefaulFilterList = {
    listUnit: [],
};

interface props {
    inforAddGroup?: IInforAddGroup
    selectedIdAccount: ISelectedUserAccount[]
    setSelectedIdAccount: React.Dispatch<React.SetStateAction<ISelectedUserAccount[]>>
}

const AG_Decentralization: React.FC<props> = ({
    inforAddGroup, selectedIdAccount,
    setSelectedIdAccount
}) => {
    const pushLoading = useLoading()
    const { groupPermission } = useSelector(selectorInfoUser)
    const {
        // sLUnit,
        sLNationwide,
    } = useCustomerGroupContext();



    const isRestoringSelection = useRef(false);
    const gridApiRef = useRef<GridApi | null>(null);
    const columnDefsMemo = useMemo<ColDef[]>(() => columnDefs, []);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
    const [tabPermission, setTabPermission] = useState(PERMISSION.VIEW)

    const [dataFilterList, setDataFilterList] = useState<IDataDefaulFilterList>(dataDefaulFilterList)

    const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

    const [listUserAccount, setListUserAccount] = useState<IAccount[]>([]);

    const [permissionByUserId, setPermissionByUserId] = useState<
        Record<string, PERMISSION>
    >({});

    const permissionLabelMap: Record<PERMISSION, string> = {
        [PERMISSION.VIEW]: "Xem",
        [PERMISSION.EDIT]: "Sửa",
        [PERMISSION.DELETE]: "Sửa, Xóa",
    };

    const defaultColDef = useMemo<ColDef>(
        () => ({
            resizable: true,
            flex: 1,
            valueFormatter: (params: any) =>
                params.value && String(params.value).trim() !== ""
                    ? params.value
                    : "Không xác định",
        }),
        []
    );

    const gListUserAccount = useDebounce(async (limit: number = 10, pageNumber: number = 1) => {
        pushLoading(true)
        const { listUnit, search } = dataFilterList
        const result = await getListUserAccount(
            limit, pageNumber, listUnit, undefined,
            search, groupPermission ?? undefined, 1,
        );
        if (result?.status) {
            setListUserAccount(result.data)
            setPagination({ current: pageNumber, total: result.total, pageSize: limit });

        } else {
            // pushToast(result.message, "error", 2000);
        }
        pushLoading(false)
    }, 1000)

    const rowData = useMemo(() => {
        return (listUserAccount ?? []).map((item: any) => {
            const userId = String(item.id);
            const permission = permissionByUserId[userId];

            return {
                ...item,
                permission:
                    permission !== undefined
                        ? permissionLabelMap[permission]
                        : undefined,
            };
        });
    }, [listUserAccount, permissionByUserId]);
    //------------------------------------
    // Định danh duy nhất cho mỗi row
    const getRowId = useCallback((p: { data: any }) => String(p.data.id), []);

    // --- Grid ready ---
    const onGridReady = useCallback((params: { api: GridApi }) => {
        gridApiRef.current = params.api;
    }, []);

    // --- Selection change ---
    const onSelectionChanged = useCallback(
        (event: SelectionChangedEvent) => {
            if (isRestoringSelection.current) return;

            const api = event.api;

            const selectedNodes = api.getSelectedNodes().filter((n) => n.data);
            const selectedIdsOnPage = selectedNodes.map((n) => String(n.data.id));

            const currentPageIds = (listUserAccount ?? []).map((row: any) =>
                String(row.id)
            );

            const nextSet = new Set(selectedIds);

            const added: string[] = [];
            const removed: string[] = [];

            for (const id of currentPageIds) {
                const isCurrentlySelected = selectedIdsOnPage.includes(id);
                const wasPreviouslySelected = selectedIds.has(id);

                if (isCurrentlySelected && !wasPreviouslySelected) {
                    added.push(id);
                    nextSet.add(id);
                } else if (!isCurrentlySelected && wasPreviouslySelected) {
                    removed.push(id);
                    nextSet.delete(id);
                }
            }

            // Cập nhật quyền cho row vừa được chọn
            if (added.length > 0) {
                setPermissionByUserId((prev) => {
                    const next = { ...prev };

                    added.forEach((id) => {
                        next[id] = tabPermission;
                    });

                    return next;
                });
            }

            // Nếu bỏ chọn thì xóa quyền khỏi row đó
            if (removed.length > 0) {
                setPermissionByUserId((prev) => {
                    const next = { ...prev };

                    removed.forEach((id) => {
                        delete next[id];
                    });

                    return next;
                });
            }

            handleChangeSelectedUserAccount(added, removed);

            setSelectedIds(nextSet);
        },
        [selectedIds, listUserAccount, tabPermission]
    );
    //------------------------------------

    // --- Cập nhật danh sách account được chọn ---
    const handleChangeSelectedUserAccount = (itemsAdd: string[], itemsRemove: string[]) => {
        setSelectedIdAccount((prevList) => {
            // Nếu có add
            if (itemsAdd.length > 0) {
                const newUsers = itemsAdd.map((id) => ({
                    adminId: Number(id),
                    permissionType: tabPermission,
                }));
                return [...prevList, ...newUsers];
            }

            // Nếu có remove
            if (itemsRemove.length > 0) {
                return prevList.filter((user) => !itemsRemove.includes(user.adminId.toString()));
            }

            return prevList;
        });
    };

    // --- Khi đổi page ---
    const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        gListUserAccount(pageSize, pageNumber);
    };

    // --- Khôi phục selection khi data mới load ---
    useEffect(() => {
        if (gridApiRef.current && listUserAccount && listUserAccount.length > 0) {
            isRestoringSelection.current = true;

            gridApiRef.current.forEachNode((node: any) => {
                if (node.data && selectedIds.has(String(node.data.id))) {
                    node.setSelected(true, false, true);
                } else {
                    node.setSelected(false, false, true);
                }
            });

            setTimeout(() => {
                isRestoringSelection.current = false;
            }, 0);
        }
    }, [listUserAccount, selectedIds]);

    useEffect(() => {
        setDataFilterList(dataDefaulFilterList)
        if (inforAddGroup?.status === GROUPTYPE.SHARED) {
            //Xóa ds phân quyền đã chọn
            setSelectedIds(new Set())
            setSelectedIdAccount([])
        }
    }, [inforAddGroup?.status]);

    useEffect(() => {
        gListUserAccount()
    }, [dataFilterList])

    // useEffect(() => {
    //     console.log(inforAddGroup);

    // }, [inforAddGroup])
    return (
        <div className="custom-page-css w-full flex flex-col gap-2 bg-white rounded">
            <div className="custom-page-css flex items-start gap-2">
                <div className="custom-page-css h-fit flex-1 d-flex  gap-2 overflow-hidden">
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center  py-2-px justify-between overflow-hidden">
                        <div className="d-flex align-center  w-full">
                            <TreeSelect
                                className="w-full text-left text-span-select text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"
                                multiple
                                showSearch
                                placeholder="Chọn đơn vị"
                                allowClear
                                value={dataFilterList?.listUnit}
                                treeDefaultExpandAll={false}
                                treeData={sLNationwide}
                                filterTreeNode={(input: string, option: any) =>
                                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(e) => setDataFilterList({ ...dataFilterList, listUnit: e })}
                            />

                        </div>
                    </div>
                </div>

                <div className="custom-page-css h-fit flex-2 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-2-px justify-between overflow-hidden">
                    <Input
                        placeholder="Tìm kiếm tài khoản người dùng"
                        className='custom-input-css custom-page-css border-none custom-input-focus  none-focus-erro'
                        value={dataFilterList.search}
                        onChange={(e) => setDataFilterList({ ...dataFilterList, search: e.target.value })}
                    />
                    <div className=" border-l-F2F4F7 h-full d-flex align-center">
                        <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                    </div>
                </div>
            </div>
            <div className="custom-page-css flex  h-fit overflow-hidden  justify-between gap-1">
                <div className="custom-page-css flex items-center gap-1">
                    <span className='custom-page-css text-base text-4B4B4B font-regular'>Đã chọn:</span>
                    <span className='custom-page-css text-base text-344054 font-regular'>{formatPrice(selectedIds.size)} khách hàng</span>
                </div>
                <div className="custom-page-css flex items-center justify-end gap-2">
                    <div className={`${tabPermission === PERMISSION.VIEW ? 'border-40A9FF bg-E6F7FF' : 'border'} custom-page-css flex items-center justify-center py-1 px-3  rounded-3xl  cursor-pointer`}
                        onClick={() => setTabPermission(PERMISSION.VIEW)}
                    >
                        <span className={`${tabPermission === PERMISSION.VIEW ? 'text-40A9FF' : 'text-98A2B3 '} custom-page-css text-base font-regular`}>Xem</span>
                    </div>
                    <div className="custom-page-css divider"></div>
                    <div className={`${tabPermission === PERMISSION.EDIT ? 'border bg-E6F7FF' : 'border'} custom-page-css flex items-center justify-center py-1 px-3  rounded-3xl  cursor-pointer`}
                        onClick={() => setTabPermission(PERMISSION.EDIT)}
                    >
                        <span className={`${tabPermission === PERMISSION.EDIT ? 'text-40A9FF' : 'text-98A2B3 '} custom-page-css text-base font-regular`}>Sửa</span>
                    </div>
                    <div className="custom-page-css divider"></div>
                    <div className={`${tabPermission === PERMISSION.DELETE ? 'border bg-E6F7FF' : 'border'} custom-page-css flex items-center justify-center py-1 px-3  rounded-3xl  cursor-pointer`}
                        onClick={() => setTabPermission(PERMISSION.DELETE)}
                    >
                        <span className={`${tabPermission === PERMISSION.DELETE ? 'text-40A9FF' : 'text-98A2B3 '} custom-page-css text-base font-regular`}>Sửa, Xóa</span>
                    </div>
                </div>
            </div>

            <div className={`order-history-card__body `}>
                <div className="ag-theme-alpine  custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
                    <AgGridReact
                        className="my-auto-height-grid"
                        getRowStyle={(params: any) => ({
                            backgroundColor: params?.node?.rowIndex % 2 ? "#f7f9fc" : "#ffffff",
                        })}
                        rowData={rowData}
                        columnDefs={columnDefsMemo}
                        rowHeight={55}
                        defaultColDef={defaultColDef}
                        overlayNoRowsTemplate={NodataTable}
                        rowSelection={{ mode: 'multiRow' }} selectionColumnDef={{ pinned: 'left', lockPosition: 'left', suppressMovable: true }}
                        getRowId={getRowId}
                        onGridReady={onGridReady}
                        onSelectionChanged={onSelectionChanged}
                        maintainColumnOrder
                    />
                </div>
                <ConfigProvider locale={viVN}>
                    <div className="pagination-block">
                        <Pagination
                            showSizeChanger
                            current={pagination.current}
                            pageSize={pagination.pageSize}
                            total={pagination.total}
                            itemRender={(page, type, originalElement) => {
                                // Chỉ custom khi là nút số trang
                                if (type === 'page') {
                                    return <span>{formatNumber(page)}</span>;
                                }
                                // prev / next / jump-prev / jump-next giữ nguyên
                                return originalElement;
                            }}
                            showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                            className='rs-pagination'
                            onChange={onPaginationChange}
                        />
                    </div>
                </ConfigProvider>
            </div>
        </div>
    )
}
export default AG_Decentralization
